module.exports = __webpack_public_path__ + "static/media/PKLogo.0019afe0.png";